import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class FileUploadService {

  public externalUpload(url: string, file: File, onComplete: (r: Response) => void): void {
    const reader = new FileReader();
    let listener = (event: any) => {
      fetch(url, {
        method: 'PUT',
        mode: 'cors',
        headers: {
          'content-type': file.type
        },
        body: event.target.result
      }).then(r => {
        console.log(`Uploaded file to ${file.name} with status ${r.status} and message ${r.statusText}`)
        if (r.status >= 400) {
          console.error(`Uploaded file to ${file.name} with status ${r.status} and message ${r.statusText}`)
        }
        this.runOnComplete(r, onComplete);
      });
    };
    reader.addEventListener("load", listener, false);
    reader.readAsArrayBuffer(file);
  };

  runOnComplete(response: Response, onComplete: (r: Response) => void) {
    if (onComplete) {
      onComplete(response);
    }
  }

}
